import styled from 'styled-components';
import { ReactComponent as NewModule } from '../../spark.svg';
import { ReactComponent as Comm } from './sidebar-communication.svg';
import { ReactComponent as Calendar } from './sidebar-calendar.svg';
import { ReactComponent as Clients } from './sidebar-client.svg';
import { ReactComponent as Finance } from './sidebar-finance.svg';
import { ReactComponent as Reports } from './reports.svg';
import { ReactComponent as Suppliers } from './sidebar-suppliers.svg';
import { ReactComponent as Settings } from './sidebar-settings.svg';
import { ReactComponent as Timesheet } from './sidebar-timesheet.svg';
import { ReactComponent as Workers } from './workers-white.svg';

const createIconVariants = (IconComponent, styles) => {
  const Dark = styled(IconComponent)`
    ${({ theme }) => styles.dark(theme)}
  `;

  const Active = styled(IconComponent)`
    ${({ theme }) => styles.active(theme)}
  `;

  return { Dark, Active };
};

const iconStyles = {
  workers: {
    dark: (theme) => `
      path:first-of-type {
        fill: ${theme.colors.grey4};
      }
      path:last-of-type {
        stroke: ${theme.colors.grey4};
      }
    `,
    active: (theme) => `
      path:first-of-type {
        fill: ${theme.colors.primary};
      }
      path:last-of-type {
        stroke: ${theme.colors.primary};
      }
    `
  },
  reports: {
    dark: (theme) => `
      path:first-of-type {
        fill: ${theme.colors.grey4};
        stroke: ${theme.colors.grey4};
      }
      path:last-of-type {
        stroke: ${theme.colors.grey4};
      }
    `,
    active: (theme) => `
      path:first-of-type {
        fill: ${theme.colors.primary};
        stroke: ${theme.colors.primary};
      }
      path:last-of-type {
        stroke: ${theme.colors.primary};
      }
    `
  },
  comm: {
    dark: (theme) => `
      path:first-of-type {
        stroke: ${theme.colors.grey4};
      }
      path:not(:first-of-type) {
        fill: ${theme.colors.grey4};
      }
    `,
    active: (theme) => `
      path:first-of-type {
        stroke: ${theme.colors.primary};
      }
      path:not(:first-of-type) {
        fill: ${theme.colors.primary};
      }
    `
  },
  default: {
    dark: (theme) => `
      path {
        fill: ${theme.colors.grey4};
      }
    `,
    active: (theme) => `
      path {
        fill: ${theme.colors.primary};
      }
    `
  },
  suppliers: {
    dark: (theme) => `
      path {
        stroke: ${theme.colors.grey4};
      }
    `,
    active: (theme) => `
      path {
        stroke: ${theme.colors.primary};
      }
    `
  }
};

const { Dark: WorkersDark, Active: WorkersActive } = createIconVariants(Workers, iconStyles.workers);

const { Dark: ReportsDark, Active: ReportsActive } = createIconVariants(Reports, iconStyles.reports);

const { Dark: CommDark, Active: CommActive } = createIconVariants(Comm, iconStyles.comm);

const { Dark: CalendarDark, Active: CalendarActive } = createIconVariants(Calendar, iconStyles.default);

const { Dark: ClientsDark, Active: ClientsActive } = createIconVariants(Clients, iconStyles.default);

const { Dark: FinanceDark, Active: FinanceActive } = createIconVariants(Finance, iconStyles.default);

const { Dark: SuppliersDark, Active: SuppliersActive } = createIconVariants(Suppliers, iconStyles.suppliers);

const { Dark: SettingsDark, Active: SettingsActive } = createIconVariants(Settings, iconStyles.default);

const { Dark: TimesheetDark, Active: TimesheetActive } = createIconVariants(Timesheet, iconStyles.default);

const ModuleIconsLight = { Calendar, Clients, Comm, Finance, Reports, Settings, Suppliers, Timesheet, Workers };
const ModuleIconsDark = {
  CommDark,
  CalendarDark,
  ClientsDark,
  FinanceDark,
  ReportsDark,
  SuppliersDark,
  SettingsDark,
  TimesheetDark,
  WorkersDark
};
const ModuleIconsActive = {
  CommActive,
  CalendarActive,
  ClientsActive,
  FinanceActive,
  ReportsActive,
  SuppliersActive,
  SettingsActive,
  TimesheetActive,
  WorkersActive
};
const CommonModuleIcons = {
  NewModule
};

const ModuleIcons = { ModuleIconsLight, ModuleIconsDark, ModuleIconsActive, CommonModuleIcons };
export default ModuleIcons;
